import { gql } from '../../../../types/__codegen__/ahm-api';

export const PRODUCTS_WITH_SERVICES = gql(`
  query fetchProductsWithServices($extrasInput: ProductWithServiceInput, $hospitalInput: ProductWithServiceInput) {
    extras: productsWithServices(input: $extrasInput)
    hospital: productsWithServices(input: $hospitalInput)
  }
`);
